(() => {
  if (window.__abmQuoteReady) return;
  window.__abmQuoteReady = true;

  const moneyText = node => (node?.textContent || '').replace(/\s+/g, ' ').trim();

  const syncProductQuote = dialog => {
    const root = dialog.closest('[data-abm-product]') || document.querySelector('[data-abm-product]');
    if (!root) return;

    const variantId = root.querySelector('[data-abm-variant-id]')?.value || '';
    const sku = moneyText(root.querySelector('[data-abm-sku]')) || 'N/A';
    const quantity = Math.max(1, Number.parseInt(root.querySelector('[data-abm-product-form] [name="quantity"]')?.value || '1', 10) || 1);
    const price = moneyText(root.querySelector('[data-abm-price]'));
    const title = dialog.dataset.productTitle || '';
    const vendor = dialog.dataset.productVendor || '';
    const url = window.location.href;

    const variantInput = dialog.querySelector('[data-abm-quote-variant]');
    const skuInput = dialog.querySelector('[data-abm-quote-sku]');
    const quantityInput = dialog.querySelector('[data-abm-quote-quantity]');
    if (variantInput) variantInput.value = variantId;
    if (skuInput) skuInput.value = sku;
    if (quantityInput) quantityInput.value = String(quantity);

    const body = dialog.querySelector('[data-abm-quote-body]');
    if (body) {
      body.value = [
        'ABMIUM product quotation request',
        `Product: ${title}`,
        `Manufacturer: ${vendor}`,
        `Variant ID: ${variantId || 'N/A'}`,
        `SKU: ${sku}`,
        `Quantity: ${quantity}`,
        `Unit price shown: ${price || 'N/A'}`,
        `URL: ${url}`,
      ].join('\n');
    }
  };

  const syncCartQuote = dialog => {
    const root = dialog.closest('[data-abm-marketplace-cart]') || document.querySelector('[data-abm-marketplace-cart]');
    if (!root) return;

    const rows = Array.from(root.querySelectorAll('[data-abm-quote-line]'));
    const items = rows.map((row, index) => {
      const quantity = Math.max(0, Number.parseInt(row.querySelector('input[name="updates[]"]')?.value || '0', 10) || 0);
      const details = [
        `${index + 1}. ${quantity} x ${row.dataset.title || 'Product'}`,
        `Manufacturer: ${row.dataset.vendor || 'N/A'}`,
        `SKU: ${row.dataset.sku || 'N/A'}`,
      ];
      if (row.dataset.variant) details.push(`Variant: ${row.dataset.variant}`);
      details.push(`Unit price shown: ${row.dataset.unitPrice || 'N/A'}`);
      details.push(`URL: ${row.dataset.url || ''}`);
      return details.join('\n');
    });

    const subtotal = moneyText(root.querySelector('[data-abm-cart-subtotal]'));
    const body = dialog.querySelector('[data-abm-quote-body]');
    if (body) {
      body.value = [
        'ABMIUM cart quotation request',
        subtotal ? `Current cart subtotal: ${subtotal}` : '',
        'Requested items:',
        items.join('\n\n'),
      ].filter(Boolean).join('\n');
    }
  };

  const syncDialog = dialog => {
    if (!dialog) return;
    if (dialog.dataset.abmQuoteMode === 'cart') syncCartQuote(dialog);
    else syncProductQuote(dialog);
  };

  const openDialog = dialog => {
    if (!dialog) return;
    syncDialog(dialog);
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    window.setTimeout(() => dialog.querySelector('input:not([type="hidden"])')?.focus(), 0);
  };

  const closeDialog = dialog => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-abm-quote-open]');
    if (opener) {
      event.preventDefault();
      openDialog(document.getElementById(opener.dataset.abmQuoteOpen));
      return;
    }

    const closer = event.target.closest('[data-abm-quote-close]');
    if (closer) {
      event.preventDefault();
      closeDialog(closer.closest('[data-abm-quote-dialog]'));
    }
  });

  document.addEventListener('submit', event => {
    const form = event.target.closest('.abm-quote__form');
    if (form) syncDialog(form.closest('[data-abm-quote-dialog]'));
  });

  const boot = () => {
    document.querySelectorAll('[data-abm-quote-dialog]').forEach(dialog => {
      if (dialog.querySelector('[data-abm-quote-success],[data-abm-quote-errors]')) openDialog(dialog);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
